import React from 'react';
import { useIntl } from 'react-intl';

import { IconLocationPin } from '@xingternal/icons';

import { useLocationAutocompletion } from './useLocationAutoComplete';

import { StyledAutoComplete } from '../JobsSearch.style';

const LocationAutoComplete = ({ onValueChange, value }) => {
  const { formatMessage } = useIntl();
  const {
    fetchLocationSuggestions,
    locationSuggestions,
  } = useLocationAutocompletion();

  const onChange = query => {
    fetchLocationSuggestions(query);

    if (query !== value) {
      onValueChange(query);
    }
  };

  const onSelect = query => {
    onValueChange(query);
  };

  return (
    <StyledAutoComplete
      id="location-auto-complete"
      placeholder={formatMessage({
        id: 'WELCOME_STARTPAGE_JOBS_VERSION_LOCATION_INPUT_PLACEHOLDER',
        defaultMessage: 'Location',
      })}
      variant="inputBar"
      suggestions={locationSuggestions}
      value={value}
      onChange={onChange}
      onSelect={onSelect}
      icon={IconLocationPin}
      size="large"
    />
  );
};

export default LocationAutoComplete;
